// Botón del chat en la cabecera (decisión D39) con el globito de mensajes sin leer. Es lo único del chat que viene en
// la primera carga: el resto (pantallas y motor) se carga aparte.
import { Icono } from '@reparto/ui';
import { useNavigate } from 'react-router';
import { db } from '../datos/db';
import { useVivo } from '../datos/vivo';

async function noLeidos() {
  const [convs, habilitado] = await Promise.all([db.chatConversaciones.toArray(), db.chatMarcas.get('habilitado')]);
  const ahora = new Date().toISOString();
  // Las silenciadas no suman al globito (como en WhatsApp, siguen marcadas en la lista).
  const n = convs.reduce((s, c) => s + (c.silenciada_hasta && c.silenciada_hasta > ahora ? 0 : c.no_leidos || 0), 0);
  return { n, habilitado: habilitado?.valor !== false };
}

export function BotonChat() {
  const navegar = useNavigate();
  const { n, habilitado } = useVivo(noLeidos, [], { n: 0, habilitado: true });
  if (!habilitado) return null;
  return (
    <button
      type="button"
      onClick={() => navegar('/chat')}
      className="relative grid h-10 w-10 shrink-0 place-items-center rounded-full bg-white/10"
      aria-label={n ? `Chat: ${n} sin leer` : 'Chat'}
      title="Chat"
    >
      <Icono nombre="chat" />
      {n ? (
        <span className="absolute -top-1 -right-1 grid h-5 min-w-5 place-items-center rounded-full bg-amber-400 px-1 text-[11px] leading-none font-bold text-stone-900 tabular-nums ring-2 ring-primary-800">
          {n > 99 ? '99+' : n}
        </span>
      ) : null}
    </button>
  );
}
